import React, { FC } from 'react';
import classNames from 'classnames';
import css from './BasketSetsSelectionSlider.module.scss';
import { TCurrentSetType } from '../BasketSetsSelection';

const imgCollectionRecord = {
    ny: ['ny1', 'ny2', 'ny3', 'ny4', 'ny5'],
    romantic: ['romantic1', 'romantic3', 'romantic6', 'romantic7'],
    maslenitsa: ['maslenitsa1', 'maslenitsa2', 'maslenitsa3', 'maslenitsa4'],
    green: ['green1', 'green2', 'green3', 'green4', 'green5', 'green6'],
    march: ['march1', 'march2', 'march3', 'march4', 'march5'],
    marchgifts: ['marchgifts1', 'marchgifts2', 'marchgifts3'],
    easter: ['easter1', 'easter2', 'easter3', 'easter4', 'easter5'],
    dacha: ['dacha1', 'dacha2', 'dacha3'],
    squidgame: ['squidgame1', 'squidgame2', 'squidgame3', 'squidgame4', 'squidgame5', 'squidgame6'],
    film: ['film1', 'film2', 'film3', 'film4', 'film5', 'film6', 'film7', 'film8', 'film9', 'film10'],
    halloween: ['halloween1', 'halloween2', 'halloween3', 'halloween4', 'halloween5', 'halloween6'],
    fast: ['fast1', 'fast2', 'fast3', 'fast4', 'fast5', 'fast6', 'fast7', 'fast8'],
    odyssey: ['odyssey1', 'odyssey2', 'odyssey3', 'odyssey4'],
    gryadka: ['gryadka1', 'gryadka2', 'gryadka3', 'gryadka4'],
    school: ['school1', 'school2', 'school3'],
    harry: ['harry2', 'harry3', 'harry4', 'harry5', 'harry6', 'harry7', 'harry8', 'harry9', 'harry10', 'harry11'],
};

interface IBasketSetsSelectionSliderProps {
    setName: TCurrentSetType
}

export const BasketSetsSelectionSlider = (props: IBasketSetsSelectionSliderProps) => {
    const { setName } = props;
    return (
        <div className={css.basketSetsSelectionSliderRoot}>
            {/* @ts-ignore */}
            {imgCollectionRecord[setName].map((slide: string) => {
                const classes = classNames({
                    [css.basketSetsSelectionSliderCard]: true,
                    [css[slide]]: true,
                });
                return (
                    <div
                        key={slide}
                        className={classes}
                    />
                );
            })}
        </div>
    );
};

